import React, { useEffect, useState } from 'react'
import ClientLayout from './ClientLayout'
import { GetAccess } from '../../../../Components/Utils/roles';
import { Link, useParams } from 'react-router-dom';
import UseGetDataSearch from '../../../../Components/Hooks/useFetchDataBySearch';
import ViewIcon from '../../../../Components/Icons/ViewIcon';
import NuDate from '../../../../Components/Utils/NuDate';
import MobileInvoiceIndex from '../../../Mobile/ClientManage/ClientMoblie/MobileInvoiceIndex';
import NuAmount from '../../../../Components/Utils/NuAmount';





function Invoice() {
         const { clientViewId } = useParams();

          const [params, setParams] = useState({
                     //    page: page,
                     //    per_page: pageCount,
                     //    search:searchQuery||"",
                    
                        status:"",
                        rfqAssignee:"",
                        salesPerson:"",
                        deadLineFrom:"",
                        deadLineTo:"",
                        // approvalStatus:state?.approvalStatus? state.approvalStatus :"",
                        // category:state?.category? state.category :"",
                      });

                      const [screenSize, setScreenSize] = useState({
                                    width: window.innerWidth,
                                  });
                                
                                  useEffect(() => {
                                    const handleResize = () => {
                                      setScreenSize({
                                        width: window.innerWidth,
                                      });
                                    };
                                
                                    window.addEventListener("resize", handleResize);
                                
                                    return () => {
                                      window.removeEventListener("resize", handleResize);
                                    };
                                  }, []);

         const { data,getData,dataLoading } = UseGetDataSearch( `/invoices-outgoing/client/${clientViewId}`,params);
                  console.log(data,"contractcli");
  
  return (
    <>
    <ClientLayout 
         BackAccess={GetAccess("client_management_module")}
   
   >

{
  screenSize.width < "768" ?(<>
  <div className=' w-full h-[calc(100vh-175px)] bg-white mt-1 rounded-lg shadow-lg overflow-hidden'>
  <MobileInvoiceIndex
  data={data}
  // // total={totalCount}
  // pageIndex={page}
  // setPageIndex={setPage}
  // dataCount={pageCount}
  // setDataCount={setPageCount}
  // officeId={officeId}
  getData={getData}

  />
  </div>
  </>):(<>
     <div className="overflow-x-auto mt-0.5 rounded-md bg-white h-[calc(100vh-160px)]">
     <table className="min-w-full  text-xs text-left">
       <thead>
         <tr className="text-black font-semibold  border-b border-gray-300">
           <th className="px-4 py-2 w-[8%]">Ref.</th>
           {/* <th className="px-4 py-2">Client</th> */}
           <th className="px-4 py-2 w-[17.4%]">Invoice Date</th>

           <th className="px-4 py-2 w-[17.4%]">Amount</th>
           <th className="px-4 py-2 w-[17.4%]">Payment Due Date</th>
           {/* <th className="px-4 py-2 w-[15.83%]">Days Elapsed</th> */}

           <th className="px-4 py-2 w-[17.4%]">Mode Of Payment</th>
           <th className="px-4 py-2 w-[17.4%]">Status</th>
           <th className="px-4 py-2 w-[5%]">Action</th>
         </tr>
       </thead>
       <tbody>
         {data?.map((data) => (
           <tr key={data.id} className=" hover:bg-gray-50 rounded-md shadow-sm">
             <td className="px-4 py-2 w-[8%]">
             <Link to={`/invoice/invoice-outgoing/view/${data?.invoiceOutId}`}>
              
              {data.ref || "-"}
              </Link>
              </td>
             {/* <td className="px-4 py-2">
             <Link to={`/invoice/invoice-outgoing/view/${data?.invoiceOutId}`}>
              
              {data.clientName}
              </Link>
              
              </td> */}

<td className="px-4 py-2 w-[17.4%]">{data.paymentDueDate ? (
                       <NuDate
                         value={data?.paymentDueDate}
                         format="DD-MMM-YYYY"
                       />
                     ) : (
                       "N/A"
                     )}</td>
                     
             <td className="px-4 py-2 w-[17.4%] ">
             <Link to={`/invoice/invoice-outgoing/view/${data?.invoiceOutId}`}>

             <NuAmount  value={(data.amount || "-")}/>
              </Link>

</td>
     <td className="px-4 py-2 w-[17.4%]">{data.paymentDueDate ? (
                       <NuDate
                         value={data?.paymentDueDate}
                         format="DD-MMM-YYYY"
                       />
                     ) : (
                       "N/A"
                     )}</td>
             {/* <td className="px-4 py-2 w-[15.83%]">{data.daysElapsed}</td> */}

             <td className="px-4 py-2 w-[17.4%]">{data.modeOfPayment || "-"}</td>
             <td className="px-4 py-2 w-[17.4%]">
               {data.status || "-"}
             </td>
             <td className="px-4 py-2 text-gray-500 w-[5%]">
               <Link to={`/invoice/invoice-outgoing/view/${data?.invoiceOutId}`}
                                    state={{
                                      data: data,
                                      from: `/client-management/clients/invoice/${clientViewId}`,
                                    }}>
                           <ViewIcon color="#048178" />

</Link>
</td>
           </tr>
         ))}
       </tbody>
     </table>
   </div>
   </>)}

   </ClientLayout>
   </>
  )
}

export default Invoice
